import { render } from "./CategoryProducts.vue?vue&type=template&id=0d27857c"
import script from "./CategoryProducts.vue?vue&type=script&lang=js"
export * from "./CategoryProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__